import { FormControl, InputLabel, Select } from '@material-ui/core';
import React, { FC } from 'react';
import { createUseStyles } from 'src/theming';
import clsx from 'clsx';

const useStyles = createUseStyles({
  root: {
    minWidth: '120px !important',
    maxWidth: 300,
  },
});

const status = {
  partial: 'Livraison partielle',
  full: 'Livraison complète',
};

interface Props {
  onChange: (value: string) => void;
  value: string;
  className?: string;
}

const DeliveryStatusSelect: FC<Props> = ({ onChange, value, className }) => {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as string);
  };

  return (
    <FormControl className={clsx(classes.root, className)}>
      <InputLabel>Statut de la livraison</InputLabel>
      <Select native value={value} onChange={handleChange}>
        <option value='' />
        {Object.keys(status).map((statusKey) => (
          <option key={statusKey} value={statusKey}>
            {status[statusKey]}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default DeliveryStatusSelect;
